import type { FaireProductEntity } from "../../entity_types/product";

export const p_67wjk2bs7a: FaireProductEntity = {
  token: "p_67wjk2bs7a",
  type: "product",
  name: "Magnet ID-45 Sinking Farm, Salmon Canyon",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/6c44d5b8b359624d77d215adbdf392fb00982b28f81d8bb9bf78a21d44402520.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/dd10854c6677b61c8b05115ccc3b6c5e8ebe19c6280095db2eb98c2ca718fa95.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
